module.exports = __webpack_public_path__ + "static/media/mengxiang.93a387d4.png";